import { QueryCache, QueryClient } from '@tanstack/react-query';

const queryCache = new QueryCache();

export class IwQueryClient {
  static client: QueryClient | null = null;

  static getOrCreate() {
    if (!IwQueryClient.client) {
      IwQueryClient._create();
    }

    return IwQueryClient.client as QueryClient;
  }

  static _create() {
    IwQueryClient.client = new QueryClient({
      queryCache: queryCache,
      defaultOptions: {
        queries: {
          retry: false,
          refetchOnWindowFocus: false,
          staleTime: Infinity,
          refetchInterval: false,
          refetchOnReconnect: false,
          refetchOnMount: true,
          retryOnMount: false,
        },
      },
    });
  }

  static destroy() {
    IwQueryClient.client = null;
  }
}
